import React from "react";
//@ts-ignore
import loadable from "@loadable/component";

const BoardMembersGridContainer = loadable(
  () => import("./blocks/BoardMembersGrid")
);
const BoardMemberDetailContainer = loadable(
  () => import("./blocks/BoardMemberDetail")
);
const BlockQuoteContainer = loadable(() => import("./blocks/BlockQuote"));
const HomeHeroContainer = loadable(() => import("./blocks/HomeHero"));
const FiftyFiftyFeaturedContentContainer = loadable(
  () => import("./blocks/FiftyFiftyFeaturedContent")
);
const InternalPageHeroContainer = loadable(
  () => import("./blocks/InternalPageHero")
);
const ContentTilesContainer = loadable(() => import("./blocks/ContentTiles"));
const SplashEmbedContainer = loadable(() => import("./blocks/SplashEmbed"));
const StaffDirectoryContainer = loadable(
  () => import("./blocks/StaffDirectory")
);

const CatalogSearchContainer = loadable(() => import("./blocks/CatalogSearch"));
const PresidentsCircleContainer = loadable(
  () => import("./blocks/PresidentsCircle")
);
const VideoPlayerContainer = loadable(() => import("./blocks/VideoPlayer"));
const IconGroupContainer = loadable(() => import("./blocks/IconGroup"));
const GoogleMapContainer = loadable(() => import("./blocks/GoogleMap"));
const BreadcrumbsContainer = loadable(() => import("./blocks/Breadcrumbs"));
const TwoColumnRteContainer = loadable(() => import("./blocks/TwoColumnRte"));
const FormattedRichTextContainer = loadable(
  () => import("./blocks/FormattedRichText")
);
const DonateSelectorContainer = loadable(
  () => import("./blocks/DonateSelector")
);
const SecondaryNavigationContainer = loadable(
  () => import("./blocks/SecondaryNavigation/index")
);
const SiteSearchResultsContainer = loadable(
  () => import("./blocks/SiteSearchResults/index")
);
const ScientistOfTheDayListingContainer = loadable(
  () => import("./blocks/ScientistOfTheDayListing/index")
);
const FiftyFiftyTextContainer = loadable(
  () => import("./blocks/FiftyFiftyText/index")
);
const DigitalExhibitionListingContainer = loadable(
  () => import("./blocks/DigitalExhibitionListing/index")
);
const ScientistOfTheDayIndexContainer = loadable(
  () => import("./blocks/ScientistOfTheDayIndex/index")
);

const SearchBarContainer = loadable(() => import("./blocks/SearchBar/index"));
const ExhibitionMapContainer = loadable(
  () => import("./blocks/ExhibitionMap/index")
);

const PrimoShowcaseContainer = loadable(
  () => import("./blocks/PrimoShowcase/index")
);

// const CuratedCollectionsSelectorContainer = loadable(
//   () => import("./blocks/CuratedCollectionsSelector")
// );

const NewsListingContainer = loadable(
  () => import("./blocks/NewsListing/index")
);

const FAQsContainer = loadable(() => import("./blocks/FAQs/index"));

const SplashEventsContainer = loadable(() => import("./blocks/SplashEvents"));
const ArboretumSearchContainer = loadable(
  () => import("./blocks/ArboretumSearch")
);

const ArboretumHeadlineContainer = loadable(
  () => import("./blocks/ArboretumHeadline")
);
const TreeListingContainer = loadable(() => import("./blocks/TreeListing"));
const FeaturedTreesContainer = loadable(() => import("./blocks/FeaturedTrees"));
const ArboretumSearchResultsContainer = loadable(
  () => import("./blocks/ArboretumSearchResults")
);
const ArboretumMap = loadable(() => import("./blocks/ArboretumMap"));
const CTAContainer = loadable(() => import("./blocks/ComponentCTA"));
const ExhibitionTimelineContainer = loadable(
  () => import("./blocks/ExhibitionTimeline/index")
);
const ArboretumHeroContainer = loadable(() => import("./blocks/ArboretumHero"));

const Components = {
  kontent_item_component___home_hero: HomeHeroContainer,
  kontent_item_component___splash_embed: SplashEmbedContainer,
  kontent_item_component___content_tile: ContentTilesContainer,
  kontent_item_component___internal_page_hero: InternalPageHeroContainer,
  kontent_item_component___5050_featured_content:
    FiftyFiftyFeaturedContentContainer,
  kontent_item_component___block_quote: BlockQuoteContainer,
  kontent_item_component___board_members_grid: BoardMembersGridContainer,
  kontent_item_component___catalog_search: CatalogSearchContainer,
  kontent_item_component___board_member_detail: BoardMemberDetailContainer,
  kontent_item_component___staff_directory: StaffDirectoryContainer,
  kontent_item_component___presidents_circle: PresidentsCircleContainer,
  kontent_item_component___video_player: VideoPlayerContainer,
  kontent_item_component___icon_group: IconGroupContainer,
  kontent_item_component___google_map: GoogleMapContainer,
  kontent_item_component___breadcrumbs: BreadcrumbsContainer,
  kontent_item_component___two_column_rte: TwoColumnRteContainer,
  kontent_item_component___formatted_rich_text: FormattedRichTextContainer,
  kontent_item_component___donate_selector: DonateSelectorContainer,
  kontent_item_component___secondary_navigation: SecondaryNavigationContainer,
  kontent_item_component___site_search_results: SiteSearchResultsContainer,
  kontent_item_component___scientist_of_the_day_listing:
    ScientistOfTheDayListingContainer,
  kontent_item_component___fifty_fifty_text: FiftyFiftyTextContainer,
  // kontent_item_component___curated_collections_selector:
  //   CuratedCollectionsSelectorContainer,
  kontent_item_component___news_listing: NewsListingContainer,
  kontent_item_component___faqs: FAQsContainer,
  kontent_item_component___splash_events: SplashEventsContainer,
  kontent_item_component___digital_exhibition_listing:
    DigitalExhibitionListingContainer,
  kontent_item_component___search_bar: SearchBarContainer,
  kontent_item_component___scientist_of_the_day_index:
    ScientistOfTheDayIndexContainer,
  kontent_item_component___arboretum_search: ArboretumSearchContainer,
  kontent_item_component___arboretum_headline: ArboretumHeadlineContainer,
  kontent_item_component___tree_listing: TreeListingContainer,
  kontent_item_component___featured_trees: FeaturedTreesContainer,
  kontent_item_component___arboretum_search_results:
    ArboretumSearchResultsContainer,
  kontent_item_component___arboretum_map: ArboretumMap,
  kontent_item_component___cta: CTAContainer,
  kontent_item_component___exhibition_map: ExhibitionMapContainer,
  kontent_item_component___exhibition_timeline: ExhibitionTimelineContainer,
  kontent_item_component___arboretum_hero: ArboretumHeroContainer,
  kontent_item_component___primo_showcase: PrimoShowcaseContainer,
};

const ReferenceComponent = ({
  name,
  ...props
}: {
  name: string;
  id: string;
  pageId: string;
}) => {
  //@ts-ignore
  let Component = Components[name];

  if (!Component) return null;

  return <Component {...props} />;
};

export default ReferenceComponent;
